// ReportsLayout — pushes <ReportsNav /> into the SidebarContext slot for the
// Reports module's route subtree, then renders <Outlet /> for the page.
//
// Same nav-injection pattern as SkipLayout / WeighbridgeLayout / Collections-
// Layout. ReportsNav unmounts cleanly when the user leaves /reports/*, so the
// next module starts from a clean sidebar slot.

import { Outlet } from 'react-router-dom';
import { useSidebarContent } from '../../components/shell/SidebarContext';
import { ReportsNav } from './ReportsNav';

const REPORTS_NAV = <ReportsNav />;

export function ReportsLayout() {
  useSidebarContent(REPORTS_NAV);
  return <Outlet />;
}
